import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIconButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { AppRoutes } from '../app/app.routes';
import { FormField } from '@angular/forms/signals';
import { MatIcon } from '@angular/material/icon';
import { InputWrapper } from '../shared/input-wrapper/input-wrapper';
import { ButtonDirective } from '../shared/button/button.directive';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ButtonDirective,
  ]
})
export class LoginComponent {
  private router = inject(Router);
  private authService = inject(AuthService);

  public ssoLogin(): void {
    this.authService.redirectToSSOLogin();
  }

  private async afterLoginRedirect(returnUrl?: string): Promise<void> {
    returnUrl
      ? await this.router.navigateByUrl(returnUrl)
      : await this.router.navigate([AppRoutes.home], { relativeTo: null });
  }
}
